module.exports = __webpack_public_path__ + "static/media/booking.939f7d3f.svg";